export interface AccessDataValues {
  cellphoneNumber: string;
  countryCode: string;
  countryDialCode: string;
  email: string;
  password: string;
}

export interface ProfessionalDataValues {
  document: string;
  fullName: string;
  birthDate: string;
  counsel: 'CRM' | 'CRO';
  UFRegister: string;
  registerNumber: string;
}

export const defaultAccessData: AccessDataValues = {
  cellphoneNumber: '',
  countryCode: 'BR',
  countryDialCode: '+55',
  email: '',
  password: '',
};
